<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('NIRVAR Sritys') }}</h1>
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      title="Atnaujinti NIRVAR sritis dabar"
      :loading="loading"
      @click.native.stop="callInformModal()"
    />

    <!-- search -->
    <nirvar-limit-search
      :loading="loading"
      @search="searchNirvarLimits"
    />

    <nirvar-emails />

    <nirvar-mapped 
      @update-table="updateTable"
      ref="nirvarConfig"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item, 'edit')"
            @viewItem="editItem(item, 'view')"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <!-- modals -->
     <modal-custom
      :title="$t('Atnaujinti NIRVAR sritis dabar')"
      :text="$t('Ar tikrai norite tęsti NIRVAR sričių gavimą dabar?')"
      trueText="Tęsti"
      falseText="Atšaukti"
      :loading="loading"
      mid
      v-model="showInformModal"
      @confirmData="confirmAction"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'
import NirvarLimitSearch from './NirvarLimitSearch'
import NirvarEmails from './NirvarEmails'
import NirvarMapped from './NirvarMapped'
import ModalCustom from '@/components/modals/ModalCustom'

export default {
  name: 'NirvarLimit',
  components: {
    NirvarLimitSearch, NirvarEmails, NirvarMapped, ModalCustom
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: false,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 10,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      tableClassifiers: [],
      showInformModal: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Kodas'),
          align: 'start',
          value: 'nar_code',
        },
        {
          text: this.$t('NIRVAR Srities pavadinimas'),
          align: 'start',
          value: 'name',
        },
        {
          text: this.$t('Paslaugų / veiksmų skaičius'),
          align: 'start',
          value: 'action_count',
        },
        {
          text: this.$t('Komentas'),
          align: 'start',
          value: 'comment',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {},
  methods: {
    callInformModal(){
      this.showInformModal = true
    },
    updateTable(){
       this.getData()
    },
    rowClass(item) {
      if(item.color){
        let dynamicClassName = `row-class-${item.color.replace('#','')}`
        if (!document.querySelector(`.${dynamicClassName}`)) {
          const styleElement = document.createElement('style');
          styleElement.innerHTML = 
          `.${dynamicClassName} 
          { 
            background-color: ${item.color}; 
            &:hover{
              background-color:${item.color} !important;
            }
          }`;
          document.head.appendChild(styleElement);
        }
        return dynamicClassName;
      }
      return ''
    },
    confirmAction(){
      this.refreshList()
    },
    refreshList() {
      this.loading = true
      this.pageloading = true
      this.paginationloading = true
      this.$axios
        .post(`nirvar/update-list`)
        .then((res) => {
          this.getData()
          this.$refs.nirvarConfig.getParameter()
          this.$root.$emit('DATA_OK', 'Sritys atnaujintos')
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.showInformModal = false
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`nirvar/list`, data)
        .then((res) => {
          this.listData = res.data.nirvars
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    editItem(item, mode) {
      this.$router.push({
        name: 'nirvarLimitForm',
        params: {
          id: item.id,
        },
      })
    },
    searchNirvarLimits(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
